// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawerCanvas {\n  position: absolute;\n  top: 0;\n  left: 22px;\n  /* border: 1px solid red;  */\n}\n\n.pdfContainer {\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  width: 100%;\n  background-color: rgba(239, 239, 247, 0.5098039216);\n}\n\n.facsimImg {\n  margin-left: 30px;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n.pdfContent {\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
